const key = {
  TOKEN: "3499483a4e1ddfa04a6776fa92f37d85",
  CUSTOMER_TOKEN: "customer_3499483a4e1ddfa04a6776fa92f37d85",
};

export default key;
